import { formatPrice, isNumber, keepDecimal, formatNumEndWithStr, thousands } from './format-number';

/**
 * 保留两位小数
 * 一个取名字的错误典范
 * 现在保留两位小数了 -_-!
 *
 * @param num 需要格式化的数字
 * @param defaultValue 需要格式化的数字不和法的兜底值
 */
function dotOne(num: number, defaultValue = '-'): string | typeof num {
  if (!isNumber(num)) return defaultValue;
  num = +num;
  return keepDecimal(num, 2, 0.01);
}

/**
 * 格式化 9 变成 "09"
 *
 * @param num
 */
function addZero(num: number): string | typeof num {
  if (typeof num !== 'number') return num;
  if (num < 0) num = 0;

  num = +num;

  if (num >= 10) return num;

  return '0' + num;
}

/**
 * 格式化 9 变成 "09"
 *
 * @param num
 */
function yuan2fen(num: number): number | typeof num {
  if (typeof num !== 'number') return num;

  return num * 100;
}

/**
 * 格式化价格 分 为 元
 *
 * @param num
 */
function fen2yuan(num: number): number | typeof num {
  if (typeof num !== 'number') return num;

  return num / 100;
}

/**
 * 格式化
 *
 * @param price
 */
function format2yuan(price: number) {
  return fen2yuan(price);
}

/**
 * 将数字（字符串数字或者数字）格式化保留两位小数
 *
 * @param value
 */
function formatPrice2Number(value: number | string): string | number {
  if (value == null) return 0;

  if (typeof value === 'string') {
    if (value.trim() === '') return 0;
    value = +value;
  }

  return dotOne(value);
}

/**
 * 格式化有后缀的数字 1111% 为 1,111%
 *
 * @param val
 */
function formatPriceWithPercent(val: number | string): string {
  return formatNumEndWithStr(val);
}

/**
 * 1-9999之间单位为‘元’，10000以上显示单位‘万元’
 *
 * @param price
 */
function sellPriceFormat(price: number) {
  if (typeof price !== 'number' || price < 10000) return thousands(price);
  // 向下保留两位小数
  return thousands(Math.floor(price / 100) / 100) + '万';
}

/**
 * 大于10万时：XX万（小数点后两位）
 * 小于10万时：纯数字
 *
 * @param num
 */
function applyNumFormat(num: number) {
  if (!num) return 0;
  if (typeof num !== 'number' || num < 100000) return num;
  // 向下保留两位小数
  return Math.floor(num / 100) / 100 + '万';
}

export {
  yuan2fen,
  fen2yuan,
  addZero,
  format2yuan,
  thousands,
  dotOne,
  formatPrice,
  formatPriceWithPercent,
  formatPrice2Number,
  isNumber,
  sellPriceFormat,
  keepDecimal,
  applyNumFormat,
};

export default {
  yuan2fen,
  fen2yuan,
  addZero,
  format2yuan,
  thousands,
  dotOne,
  formatPrice,
  formatPriceWithPercent,
  formatPrice2Number,
  isNumber,
  sellPriceFormat,
  applyNumFormat,
};
